import { useState, useEffect } from 'react';
import { StoreEditPage } from './seller/StoreEditPage';
import { DesktopStoreEditPage } from './desktop/DesktopStoreEditPage';

export function ResponsiveStoreEditPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <StoreEditPage /> : <DesktopStoreEditPage />;
}